// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { toCamelCase } from '@autopass-web/domain';
import axios from 'axios';
import { createInterceptorChain, Interceptor } from './interceptor';

export class PrettifyInterceptor extends Interceptor {
  override onIntercept = (response: any) => toCamelCase(response);
}

export const parseResponse = async (promise: any) => {
  try {
    const response = await promise;
    if (response instanceof Error || response?.hasOwnProperty('error')) {
      throw response;
    }
    return { error: null, data: response };
  } catch (error) {
    return { error };
  }
};

interface constructorProps {
  requestInterceptorChain: [];
  responseResultInterceptorChain: [];
  responseErrorInterceptorChain: [];
}

class HttpClient {
  httpClient: any;
  apiConfig: any;
  requestInterceptorChain: any;
  responseResultInterceptorChain: any;
  responseErrorInterceptorChain: any;

  constructor({
    requestInterceptorChain = [],
    responseResultInterceptorChain = [],
    responseErrorInterceptorChain = [],
  }: constructorProps) {
    this.requestInterceptorChain = createInterceptorChain([
      ...requestInterceptorChain,
    ]);
    this.responseResultInterceptorChain = createInterceptorChain([
      ...responseResultInterceptorChain,
      new PrettifyInterceptor(),
    ]);
    this.responseErrorInterceptorChain = createInterceptorChain([
      ...responseErrorInterceptorChain,
    ]);
  }

  interceptRequest = (request: any) => {
    if (this.requestInterceptorChain)
      return this.requestInterceptorChain.intercept(request);
    return request;
  };

  interceptResponseResult = (response: any) => {
    if (this.responseResultInterceptorChain)
      return this.responseResultInterceptorChain.intercept(response);
    return response;
  };

  interceptResponseError = (error: any, http: any) => {
    if (this.responseErrorInterceptorChain)
      return this.responseErrorInterceptorChain.intercept(error, http);
    return error;
  };

  createHttpClient = ({ headers, baseUrl }: { headers: any; baseUrl: any }) => {
    return axios.create({
      headers,
      baseURL: baseUrl,
      timeout: 60000,
      validateStatus: (status) => {
        return status >= 200 && status < 300;
      },
    });
  };

  // methods

  get = (apiPath = '', params = {}) =>
    parseResponse(this.httpClient.get(`${apiPath}`, { params }));
  post = (apiPath = '', params = {}, config = {}) =>
    parseResponse(this.httpClient.post(`${apiPath}`, params, config));
  patch = (apiPath = '', params = {}) =>
    parseResponse(this.httpClient.patch(`${apiPath}`, params));
  put = (apiPath = '', params = {}) =>
    parseResponse(this.httpClient.put(`${apiPath}`, params));
  delete = (apiPath = '', params = {}) =>
    parseResponse(this.httpClient.delete(`${apiPath}`, { params }));
}

export default HttpClient;
